import React from 'react';
import Layout from '../../layout/default';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Header from '../home/components/Header/Header';
import Footer from '../home/components/Footer';
import './styles.scss';
import cx from 'classnames';

function NotFound() {
  return (
    <main className={cx('home-page not-found-page', { isMobile })}>
      <Header />
      <div className="home-page-content">
        <div className="not-found-page-hero">
          <div className="left-block">
            <img src="/images/404-left-block.svg" />
          </div>
          <div className="center-block">
            <div className="center-block-circle-img" />
            <div className="center-block-content">
              <p className="not-found-number-title">404</p>
              <p className="not-found-title">
                <span className="blue-part">Oops — </span>You’ve Hit a Missing Form
              </p>
              <p className="not-found-subtitle">Looks like the page you’re looking for doesn’t exist or has been moved.</p>
              <Link to="/" className="return-home-btn">
                Return Home
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.33325 8H12.6666" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path
                    d="M8 3.33325L12.6667 7.99992L8 12.6666"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="right-block">
            <img src="/images/404-right-block.svg" />
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}

export default NotFound;
